export const airQualityWidgetConfigByType = Object.freeze({
  airQualityForecast: Object.freeze({
    mode: 'forecast',
    route: 'getAirQualityForecast',
    ariaLabel: 'Air quality forecast widget',
  }),
  airQualityObservations: Object.freeze({
    mode: 'observations',
    route: 'getAirQualityObservation',
    ariaLabel: 'Air quality observation widget',
  }),
});

export const getAirQualityWidgetConfig = (widgetType) => {
  return (
    airQualityWidgetConfigByType[widgetType] ?? airQualityWidgetConfigByType.airQualityObservations
  );
};

export const airQualityReportColumnClassNameByLayout = Object.freeze({
  '1x1': 'row-cols-1',
  '1x2': 'row-cols-1',
  '2x1': 'row-cols-2',
});
